<template>
  <HomeComponent />
  <CookieConsent class="banner" ref="banner" />
</template>

<script>
import HomeComponent from './components/Home.vue'
import CookieConsent from "./components/pages/CookieConsent.vue";

export default {
  name: 'App',
  components: {
    HomeComponent,
    CookieConsent,
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
